import { ANNOUNCER_ID } from '@/lib/announce';

/** The visually hidden, assertive live region `announce` writes to; mounted once, in the app's providers. */
export function Announcer() {
  return <div id={ANNOUNCER_ID} className="visually-hidden" aria-live="assertive" aria-atomic="true" />;
}
